import React, { PureComponent } from "react";
import { Select } from "antd";

import Spin from "components/UI/Spin";
import { callGetPaginatedEmployeeList } from "api/Employee/callGetEmployeeList";
import callGetEmployeeDetail from "api/Employee/callGetEmployeeDetail";
import "./styles.scss";

const { Option } = Select;

type EmployeeSelectProps = {
  value: string,
  onChange: (changedValue: string) => void,
  disabledUserIds: {
    [string]: boolean,
  },
  withoutPagination: Boolean,
};

export default class EmployeeSelect extends PureComponent<EmployeeSelectProps> {
  state = {
    data: [],
    meta: null,
    fetching: false,
    value: null,
    valueLoaded: false,
  };

  indexdDataInfo = {};

  keyword = "";

  static getDerivedStateFromProps(props) {
    return {
      value: props.value,
    };
  }

  componentDidMount() {
    const { value } = this.state;
    if (value) {
      this._fetchDetail(value);
    } else {
      this.setState({ valueLoaded: true });
    }
  }

  _fetchDetail = async (id) => {
    try {
      const res = await callGetEmployeeDetail({ id });
      this.indexdDataInfo[res.id] = res;
      this.setState({ valueLoaded: true, data: [res] });
    } catch (e) {
      this.setState({ valueLoaded: true });
    }
  };

  _fetchData = async (keyword, page = 1) => {
    if (this.props.withoutPagination) {
      this._fetchDataWithoutPaginate(keyword);
      return;
    }

    try {
      this.setState((prevState) => ({
        fetching: true,
        data: page > 1 ? [...prevState.data] : [],
      }));

      const res = await callGetPaginatedEmployeeList({ keyword, page });

      res.items.forEach((item) => {
        this.indexdDataInfo[item.id] = item;
      });
      this.setState((prevState) => ({
        fetching: false,
        meta: res.meta,
        data: page > 1 ? [...prevState.data, ...res.items] : res.items,
      }));
    } catch (e) {
      this.setState({ fetching: false });
    }
  };

  _fetchDataWithoutPaginate = async (keyword) => {
    try {
      this.setState({
        fetching: true,
      });

      const res = await callGetPaginatedEmployeeList({
        keyword,
        page: 1,
        limit: 10000,
      });

      res.items.forEach((item) => {
        this.indexdDataInfo[item.id] = item;
      });
      this.setState({
        fetching: false,
        meta: res.meta,
        data: res.items,
      });
    } catch (e) {
      this.setState({ fetching: false });
    }
  };

  _handleSearch = (value) => {
    this.keyword = value;
    this._fetchData(value);
  };

  _handleChange = (value) => {
    const { onChange } = this.props;
    console.log(value);
    onChange && onChange(value);
  };

  _handleScroll = (e) => {
    const { meta } = this.state;
    const element = e.target;
    const { scrollHeight, clientHeight, scrollTop } = element;
    console.log({ scrollHeight, clientHeight, scrollTop });
    if (
      scrollHeight === clientHeight + scrollTop &&
      meta &&
      meta.current_page < meta.total_pages
    ) {
      this._fetchData(this.keyword, meta.current_page + 1);
    }
  };

  _onFocus = () => {
    this._fetchData("");
  };

  render() {
    const { data, fetching, value, valueLoaded } = this.state;
    let disabledUserIds = this.props.disabledUserIds || {};
    const optionData = [...(data || []), ...(this.props.optionData || [])];
    const options = optionData.map((d) => (
      <Option key={d.id} disabled={!!disabledUserIds[d.id]}>
        ({d.identification}) {d.name}
      </Option>
    ));
    console.log(options, "options");
    return (
      <Select
        {...this.props}
        showSearch
        onPopupScroll={this._handleScroll}
        value={valueLoaded ? value : null}
        placeholder={this.props.placeholder}
        defaultActiveFirstOption={false}
        filterOption={false}
        onSearch={this._handleSearch}
        onChange={this._handleChange}
        notFoundContent={fetching ? null : "Không có dữ liệu"}
        loading={!valueLoaded}
        onFocus={this._onFocus}
        dropdownRender={(menu) => {
          return (
            <div>
              {menu}
              {fetching && (
                <div className="text-center">
                  <Spin size="small" />
                </div>
              )}
            </div>
          );
        }}
      >
        {options}
      </Select>
    );
  }
}
